import { toast } from 'react-toastify'

function RaytebForm({
  onSubmit,
  children,
  checkIsRequired,
  className,
}: FormInterface) {
  const onSubmited = (e) => {
    e.preventDefault()
    if (!checkIsRequired) {
      onSubmit?.(e)
      return
    }
    const inputs = [
      ...(e.currentTarget.getElementsByTagName('input') as HTMLCollection),
      ...(e.currentTarget.getElementsByTagName('select') as HTMLCollection),
    ]
    const inValidElements = inputs.filter(
      (n) => n.getAttribute('rayteb-reqValid') === 'true'
    )
    if (inValidElements.length !== 0) {
      for (var i = 0; i < inValidElements.length; i++) {
        toast.error(inValidElements[i].getAttribute('rayteb-reqMessage'))
      }
    } else onSubmit?.(e)
  }
  return (
    <>
      <form onSubmit={onSubmited} className={`${className ?? ''}`}>
        {children}
      </form>
    </>
  )
}

export default RaytebForm
